const SystemCommentType = {
  TRIGGER: 1,
  CLEAR: 2,
  ACKNOWLEDGED: 3,
};
// eslint-disable-next-line import/prefer-default-export
export { SystemCommentType };
